import { render, staticRenderFns } from "./OtherItem.vue?vue&type=template&id=628c5b3c"
import script from "./OtherItem.vue?vue&type=script&lang=js"
export * from "./OtherItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports